import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes__default from 'prop-types';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { Box, Container, Typography, Grid } from '@material-ui/core';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import clsx from 'clsx';
import { retrieveContentfulImage } from '../../common/image.js';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    boxCenterContainer: _defineProperty({
      padding: theme.spacing(12, 0)
    }, theme.breakpoints.down("xs"), {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(6)
    }),
    mb2: {
      marginBottom: theme.spacing(2)
    },
    mt2: {
      marginTop: theme.spacing(2)
    },
    mt3: {
      marginTop: theme.spacing(3)
    },
    mt4: {
      marginTop: theme.spacing(4)
    },
    mr1point5: {
      marginRight: theme.spacing(1.5)
    },
    mr2: {
      marginRight: theme.spacing(2)
    },
    gridItem: {
      display: "flex",
      flexDirection: "column"
    },
    imageItem: _defineProperty({
      height: theme.spacing(39),
      width: "100%",
      borderRadius: theme.spacing(1),
      objectFit: "cover"
    }, theme.breakpoints.down("xs"), {
      width: "100%",
      maxHeight: theme.spacing(24),
      objectFit: "cover"
    }),
    avatarImage: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      borderRadius: "50%"
    },
    destinationText: {
      textTransform: "uppercase"
    }
  };
});
var TestimonialsStaff = function TestimonialsStaff(_ref) {
  var bgColor = _ref.bgColor,
    title = _ref.title,
    elements = _ref.elements,
    button = _ref.button;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: classes.boxCenterContainer
  }, title && /*#__PURE__*/React__default.createElement(Box, {
    textAlign: "left"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    component: "h2"
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.mt3
  }, elements === null || elements === void 0 ? void 0 : elements.map(function (item, index) {
    var _item$image, _item$image2, _item$author, _item$author2, _item$author3, _item$author4, _item$resort, _item$resort2, _button$, _button$2, _BUTTON_TYPES$button$, _button$3, _BUTTON_TYPES$button$2, _button$4, _button$5, _item$resort3, _item$resort4, _item$resort5, _button$6;
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      key: index,
      xs: 12,
      sm: 6,
      md: 4,
      lg: 4,
      className: clsx(classes.gridItem, _defineProperty({}, classes.mb2, isExtraSmallScreen()))
    }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.imageItem,
      src: retrieveContentfulImage(item === null || item === void 0 || (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url, {
        width: 600
      }),
      alt: item === null || item === void 0 || (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.alt
    }), /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      alignItems: "center",
      mt: 3
    }, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.avatarImage,
      src: retrieveContentfulImage(item === null || item === void 0 || (_item$author = item.author) === null || _item$author === void 0 ? void 0 : _item$author.picture, {
        width: 240,
        height: 240
      }),
      alt: (item === null || item === void 0 || (_item$author2 = item.author) === null || _item$author2 === void 0 ? void 0 : _item$author2.name) || "Avatar image"
    })), /*#__PURE__*/React__default.createElement(Box, {
      ml: 2
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 || (_item$author3 = item.author) === null || _item$author3 === void 0 ? void 0 : _item$author3.name, ",", " ", item === null || item === void 0 || (_item$author4 = item.author) === null || _item$author4 === void 0 ? void 0 : _item$author4.description)), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h6",
      component: "div",
      className: classes.destinationText
    }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 || (_item$resort = item.resort) === null || _item$resort === void 0 ? void 0 : _item$resort.resortName, ", ", " ", item === null || item === void 0 || (_item$resort2 = item.resort) === null || _item$resort2 === void 0 ? void 0 : _item$resort2.country)))), /*#__PURE__*/React__default.createElement(Box, {
      className: classes.mt2
    }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: item === null || item === void 0 ? void 0 : item.text
    })), (button === null || button === void 0 || (_button$ = button[0]) === null || _button$ === void 0 ? void 0 : _button$.label) && (button === null || button === void 0 || (_button$2 = button[0]) === null || _button$2 === void 0 ? void 0 : _button$2.url) && /*#__PURE__*/React__default.createElement(Box, {
      alignItems: "left",
      mt: "auto"
    }, /*#__PURE__*/React__default.createElement(CustomButton, {
      variant: (_BUTTON_TYPES$button$ = BUTTON_TYPES[button === null || button === void 0 || (_button$3 = button[0]) === null || _button$3 === void 0 ? void 0 : _button$3.type]) === null || _BUTTON_TYPES$button$ === void 0 ? void 0 : _BUTTON_TYPES$button$.variant,
      color: (_BUTTON_TYPES$button$2 = BUTTON_TYPES[button === null || button === void 0 || (_button$4 = button[0]) === null || _button$4 === void 0 ? void 0 : _button$4.type]) === null || _BUTTON_TYPES$button$2 === void 0 ? void 0 : _BUTTON_TYPES$button$2.color,
      size: "medium",
      className: classes.mt3,
      href: (button === null || button === void 0 || (_button$5 = button[0]) === null || _button$5 === void 0 ? void 0 : _button$5.url) + (item === null || item === void 0 || (_item$resort3 = item.resort) === null || _item$resort3 === void 0 ? void 0 : _item$resort3.countrySlug) + "/" + (item === null || item === void 0 || (_item$resort4 = item.resort) === null || _item$resort4 === void 0 ? void 0 : _item$resort4.destinationSlug) + "/" + (item === null || item === void 0 || (_item$resort5 = item.resort) === null || _item$resort5 === void 0 ? void 0 : _item$resort5.resortSlug) + "/"
    }, button === null || button === void 0 || (_button$6 = button[0]) === null || _button$6 === void 0 ? void 0 : _button$6.label)));
  })))));
};
TestimonialsStaff.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  elements: PropTypes__default.array,
  button: PropTypes__default.array
};

export { TestimonialsStaff as default };
//# sourceMappingURL=TestimonialsStaff.js.map
